import PropTypes from 'prop-types';
import validUrl from 'valid-url';
import { isNilOrEmpty } from 'util/index';
import { TextField } from '@material-ui/core';
import { useField, useFormikContext } from 'formik';
import { always } from 'ramda';
import { getDisabled } from '../consts';

const validate = (value) => {
  return value && !validUrl.isUri(value) ? 'Invalid Url Format' : null;
};

const TextFieldUrl = ({
  autoComplete,
  disabled,
  name,
  onChange,
  required,
  ...props
}) => {
  const [field, meta] = useField({ name, validate });
  const value = field.value ?? '';
  const formikContext = useFormikContext();

  const error = meta?.touched && !isNilOrEmpty(meta?.error);

  return (
    <TextField
      {...field}
      {...props}
      autoComplete={autoComplete}
      disabled={getDisabled(disabled, field, meta, formikContext)}
      error={error}
      helperText={meta?.touched ? meta.error : ''}
      required={required}
      value={value}
    />
  );
};

TextFieldUrl.propTypes = {
  autoComplete: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  required: PropTypes.bool,
};

TextFieldUrl.defaultProps = {
  autoComplete: 'off',
  disabled: false,
  onChange: always,
  required: false,
};

export default TextFieldUrl;
